export function to_top_window() {
  window.scrollTo(0, 0);
}
